/* --------------------------------------------------------------------------
	Accordion
-------------------------------------------------------------------------- */

	"use strict";

	var $ = jQuery;
	import '../base/swap.js';
	
	function initAccordion() {
		var $Accordion,
			$AccordionContent,
			$AccordionSwap;

		$Accordion = $(".js-accordion");

		if (!$Accordion.length) {
			return;
		}

		$AccordionContent = $(".js-accordion-content");
		$AccordionSwap = $(".js-accordion-swap");

		$AccordionContent.attr("aria-hidden", "true");
		$AccordionSwap.attr("aria-expanded", "false");

		$Accordion.each(function() {
			calcStateClasses($(this));
			if ($(this).find(".fs-swap-active").length) {
				$(this).find(".js-accordion-content:eq(0)").attr("aria-hidden", "false");
				$(this).find(".js-accordion-item:eq(0) .js-accordion-swap").attr("aria-expanded", "true");
			}
		});
		
		$AccordionSwap.on("activate.swap", onTriggerActivate)
		              .on("deactivate.swap", onTriggerDeactivate)
					  .on("keydown", onTriggerKeydown);
		
		$(".js-accordion-expand-all").on("click", expandAll);
		$(".js-accordion-collapse-all").on("click", collapseAll);
	}

	function expandAll() {
		setAll(this, true);
	}

	function collapseAll() {
		setAll(this, false);
	}

	function setAll(element, state) {
		var el = $(element),
			accordion = el.parents(".js-accordion"),
			id = accordion.data("accordion-id"),
			count = accordion.data("accordion-count"),
			i, button;
		for (i = 1; i <= count; i++) {
			button = $("#js-accordion-swap-" + id + "-" + i);
			if (state !== button.hasClass("fs-swap-active")) {
				button.trigger("click");
			}
		}
	}

	function activeFirstAccordion(accordion) {
		$(accordion).find(".js-accordion-item:first-of-type .js-accordion-swap").focus();
	}

	function activeLastAccordion(accordion) {
		$(accordion).find(".js-accordion-item:last-of-type .js-accordion-swap").focus();
	}

	function activeNextAccordion(accordion) {
		$(accordion).next().find(".js-accordion-swap").focus();
	}

	function activePrevAccordion(accordion) {
		$(accordion).prev().find(".js-accordion-swap").focus();
	}

	function onTriggerActivate() {
		var el = $(this),
			accordion = el.parents(".js-accordion"),
			$item = accordion.find(el.data("swap-target"));
		el.attr("aria-expanded", "true");
		$item.find(".js-accordion-content").attr("aria-hidden", "false");
		$item.find("iframe[data-src]").each(function () {
			var $iframe = $(this);
			$iframe.attr("src", $iframe.attr("data-src")).removeAttr("data-src");
		});
		calcStateClasses(accordion);
	}

	function onTriggerDeactivate() {
		var el = $(this),
			accordion = el.parents(".js-accordion");
		el.attr("aria-expanded", "false");
		accordion.find(el.data("swap-target") + " .js-accordion-content").attr("aria-hidden", "true");
		calcStateClasses(accordion);
	}

	function calcStateClasses(accordion) {
		if (accordion.find(".js-accordion-swap.fs-swap-active").length) {
			accordion.addClass('js-accordion-expanded');
			accordion.removeClass('js-accordion-collapsed');
		} else {
			accordion.removeClass('js-accordion-expanded');
			accordion.addClass('js-accordion-collapsed');
		}
	}

	function onTriggerKeydown(e) {
		if ([36, 35, 38, 40].indexOf(e.keyCode) === -1) {
			return;
		}

		var $focusedElement = $(":focus"),
		    $focusedItem = $focusedElement.closest(".js-accordion-item"),
		    $closestAccordion = $(this).closest(".js-accordion");

		e.preventDefault();

		switch (e.keyCode) {
			// home
			case 36:
				activeFirstAccordion($closestAccordion);

				break;
			// end
			case 35:
				activeLastAccordion($closestAccordion);

				break;
			// up
			case 38:
				if ($focusedItem.prev().length > 0) {
					activePrevAccordion($focusedItem);
				} else {
					activeLastAccordion($closestAccordion);
				}

				break;
			// down
			case 40:
				if ($focusedItem.next().length > 0) {
					activeNextAccordion($focusedItem);
				} else {
					activeFirstAccordion($closestAccordion);
				}

				break;
		}
	}

	$(initAccordion);
